const ALL_CLASSES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

// Okul türü veritabanında tutulmadığı için okul adından çıkarıyoruz.
// Adında İLKOKUL / ORTAOKUL / LİSE geçmeyen okullar (Kolej, Bilsem vb.) tüm sınıflara açık.
export const getAllowedClassIds = (schoolName) => {
  // "ANA OKULU", "İLK OKULU", "ANA SINIFI" gibi ayrı yazımları birleştiriyoruz
  const name = (schoolName || "")
    .toLocaleUpperCase("tr-TR")
    .replace(/(ANA|İLK|ORTA)\s+(OKUL|SINIF)/g, "$1$2");

  // İmam hatip liseleri 5-12. sınıfları kapsıyor ("İMAM HATİP", "İMAM-HATİP", "İMAM- HATİP" yazımları var)
  const imamHatipLise = /İMAM\s*-?\s*HATİP\s+LİSE/.test(name);

  const allowed = [];
  if (name.includes("İLKOKUL") || name.includes("İLKÖĞRETİM"))
    allowed.push(1, 2, 3, 4);
  if (name.includes("ORTAOKUL") || imamHatipLise) allowed.push(5, 6, 7, 8);
  if (name.includes("LİSE")) allowed.push(9, 10, 11, 12);

  if (allowed.length) return allowed;
  // Sadece anaokulu olan okullar kayda kapalı ("Anaokulu ve İlkokulu" gibi birleşikler açık)
  if (name.includes("ANAOKUL") || name.includes("ANASINIF")) return [];
  return ALL_CLASSES;
};

export const CLASS_MISMATCH_MESSAGE =
  "Seçtiğiniz sınıf, okulunuzda bulunmuyor. Lütfen okulunuza uygun bir sınıf seçiniz.";
export const NO_CLASS_FOR_SCHOOL_MESSAGE =
  "Seçtiğiniz okul için şampiyonaya kayıt yapılamamaktadır. Lütfen okulunuzu kontrol ediniz.";

export const isClassAllowedForSchool = (classId, schoolName) =>
  getAllowedClassIds(schoolName).includes(Number(classId));

// Hiçbir sınıfı olmayan okullar (anaokulları) kayıt listelerinde gösterilmiyor
export const isSchoolSelectable = (schoolName) =>
  getAllowedClassIds(schoolName).length > 0;
